'use client';

import { SupportColoredIcon, SupportIcon } from '@repo/icons';
import { SideMenuItem } from '@repo/ui/side-menu-item';
import { useTranslations } from 'next-intl';
import { renderIcon } from '@/components/layout/sidebar-left/render-icon';
import { useTenant } from '@/providers/TenantProvider';

type LiveSupportProps = {
  sidebarOpen: boolean;
};

const LiveSupport = ({ sidebarOpen }: LiveSupportProps) => {
  const t = useTranslations('sidebar-left');

  const { tenantMachineName } = useTenant();

  return (
    <SideMenuItem
      text={sidebarOpen && t('live-support')}
      Icon={renderIcon(SupportIcon, SupportColoredIcon, tenantMachineName)}
      className="intercom_support"
      onClick={() => null}
      tooltipText={t('live-support')}
      showTooltip={!sidebarOpen}
    />
  );
};

export default LiveSupport;
